var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOffers = function SvgOffers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "data-name": "gift (1)",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1968"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1967"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.115 9.535V18h4.215a1.613 1.613 0 0 0 1.616-1.581V9.535Z",
    "data-name": "Path 2214"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1970"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1969"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.054 9.535v6.885a1.582 1.582 0 0 0 1.581 1.581h4.25V9.535Z",
    "data-name": "Path 2215"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1972"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1971"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.418 4.219H14.26a2.611 2.611 0 0 0 .54-1.582A2.64 2.64 0 0 0 12.164 0C10.324 0 9.791 1.326 9 3.333 8.209 1.326 7.676 0 5.836 0A2.64 2.64 0 0 0 3.2 2.637a2.611 2.611 0 0 0 .54 1.582H1.582A1.584 1.584 0 0 0 0 5.8v1.09a1.584 1.584 0 0 0 1.582 1.583h5.309V4.219H5.836a1.582 1.582 0 0 1 0-3.164c1.081 0 1.388.648 2.2 2.7.056.143.127.313.187.466h-.278V18h2.109V4.219H9.78c.061-.153.131-.322.187-.466.808-2.05 1.115-2.7 2.2-2.7a1.582 1.582 0 0 1 0 3.164h-1.058v4.256h5.309A1.584 1.584 0 0 0 18 6.891V5.8a1.584 1.584 0 0 0-1.582-1.581",
    "data-name": "Path 2216"
  })))));
};
export default SvgOffers;